module.exports = __webpack_public_path__ + "img/3-bottom.948450ae.png";